import { Component, forwardRef, Inject, OnDestroy, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AppService } from '../../../service/app.service';
import { FieldService } from '../../../service/field.service';
import { ThingAdvancedSearchAddPropertiesDialog } from '../../advanced-search/thing-advanced-search/thing-advanced-search-add-properties-dialog.component';
import { ThingAdvancedSearchComponent } from '../../advanced-search/thing-advanced-search/thing-advanced-search.component';
import { AbstractContextService } from '../../class/abstract-context-service.class';
import { AbstractSearchFieldComponent } from '../abstract-search-field.component';
import { SearchFieldService } from '../search-field.service';
import { ThingsPropertySearchInputComponent } from './things-property-search-input.component';

@Component({
    selector: 'things-search-field',
    template: require('./things-search-field.component.html'),
    styles: [require('../search-field.component.css')]
})
export class ThingsSearchFieldComponent extends AbstractSearchFieldComponent implements OnDestroy {

    @ViewChild(ThingAdvancedSearchComponent) private thingAdvancedSearch: ThingAdvancedSearchComponent;

    @ViewChild(ThingAdvancedSearchAddPropertiesDialog) private addPropertiesDialog: ThingAdvancedSearchAddPropertiesDialog;

    @ViewChildren(ThingsPropertySearchInputComponent) private thingsPropertySearchInputs: QueryList<ThingsPropertySearchInputComponent>;

    loaded: boolean;

    private tagsSubscription: Subscription;

    constructor(
        @Inject(forwardRef(() => FieldService)) fieldService: FieldService,
        @Inject(forwardRef(() => SearchFieldService)) searchFieldService: SearchFieldService,
        @Inject(forwardRef(() => MatDialog)) matDialog: MatDialog,
        @Inject(forwardRef(() => ViewContainerRef)) vcRef: ViewContainerRef,
        @Inject(forwardRef(() => AppService)) appService: AppService,
        @Inject(forwardRef(() => AbstractContextService)) private contextService: AbstractContextService
    ) {
        super(fieldService, searchFieldService, matDialog, vcRef, appService);
        this.subscribeToTags();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.tagsSubscription) {
            this.tagsSubscription.unsubscribe();
        };
        this.tagsSubscription = null;
    }

    openAddPropertiesDialog(advancedSearchProperties: { name: string, label: string }[]): void {
        this.close();
        this.advancedSearchProperties = advancedSearchProperties;
        setTimeout(() => this.addPropertiesDialog.open(), 400);
    }

    closeAddPropertiesDialog(updatedSearchFields: string[]): void {
        if (updatedSearchFields) {
            this.thingAdvancedSearch.updateSearchFields(updatedSearchFields);
        }
        setTimeout(() => this.open(), 400);
    }

    performClear(): void {
        this.thingAdvancedSearch?.clearAll();
        this.clearInputs();
    }

    protected updateAdvancedSearch(fieldsToSaveBody: any): void {
        this.thingAdvancedSearch?.updateLocalStorage(fieldsToSaveBody);
        this.thingAdvancedSearch?.initAllConfigurations();
    }

    protected getEncodedRawValues(): any {
        let body: any = {};
        this.thingsPropertySearchInputs?.forEach(property => Object.assign(body, property.getFormValue(true)));
        return body;
    }

    protected getRawValues(): any {
        let body: any = {};
        this.thingsPropertySearchInputs?.forEach(property => Object.assign(body, property.getFormValue(false)));
        return body;
    }

    protected refreshInputConfigurations(): void {
        this.thingsPropertySearchInputs.forEach(input => {
            input.refreshConfiguration();
        });
    }

    private subscribeToTags(): void {
        this.tagsSubscription = this.contextService.getTagsSubject().subscribe(() => {
            this.loaded = false;
            setTimeout(() => this.loaded = true, 10);
        });
    }

}